import { render, staticRenderFns } from "./TopStats.vue?vue&type=template&id=7d707b7c&"
import script from "./TopStats.vue?vue&type=script&lang=js&"
export * from "./TopStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports